import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import SkeletonTable from "@/components/SkeletonTable";
import { getListRuangCbt } from "@/services/getData";
import { useTahun } from "@/hooks/useTahun";

export default function SettingRuangCbtPage() {
  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: ["listRuangCbt", selectedTahun?.label],
    queryFn: () => getListRuangCbt(selectedTahun?.label),
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  );
}
